<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>>Not Found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block>
          <router-link to="/po">
            <a-icon type="rollback" />&nbsp; Return
          </router-link>
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="loading" class="margin-bottom">
            <div slot="title">
              Financing Manifest
              <small class="m-display-block m-text-small">{{
                data.manifest.no_trans_financing
              }}</small>
            </div>
            <a-popover slot="extra" trigger="click" placement="bottom" v-if="!getIsSpecialMenu">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a-button-group>
                    <a-button
                      :disabled="
                        !(
                          data.can_edit &&
                          getAuth.username == data.manifest.tlc_pembuat
                        )
                      "
                      type="dashed"
                      icon="edit"
                      @click="handleEdit"
                      >Revisi</a-button
                    >
                    <a-button
                      @click="handleCancelTrans"
                      :disabled="
                        !(
                          data.can_cancel &&
                          getAuth.username == data.manifest.tlc_pembuat
                        )
                      "
                      type="dashed"
                      icon="close-square"
                      :loading="printLoad.cancel"
                      >Cancel</a-button
                    >
                    <a-button
                      @click="handleCloseTrans"
                      :disabled="
                        !(
                          data.can_close &&
                          getAuth.username == data.manifest.tlc_pembuat
                        )
                      "
                      type="dashed"
                      icon="close-circle"
                      :loading="printLoad.cancel"
                      >Close</a-button
                    >
                  </a-button-group>
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Date Financing</span>
                  <span class="m-list-desc"
                    >{{
                      data.manifest.offering_letter_date
                        ? moment(
                            data.manifest.offering_letter_date,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        : "-"
                    }}
                  </span>
                </li>
                <li>
                  <span class="m-list-title" for>User Creator</span>
                  <span class="m-list-desc">{{
                    data.manifest.user_pembuat
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Type - No Financing</span>
                  <span class="m-list-desc"
                    >{{
                      data.manifest.type_financing == "FP" ? "Non KMK" : "KMK"
                    }}
                    - {{ data.manifest.offering_letter_number }}</span
                  >
                </li>
                <li>
                  <span class="m-list-title" for>Nama Peminjam</span>
                  <span class="m-list-desc">{{ data.manifest.debitur }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Bentuk Kredit</span>
                  <span class="m-list-desc">{{
                    data.manifest.bentuk_kredit
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Keperluan</span>
                  <span class="m-list-desc">{{ data.manifest.keperluan }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Suku Bunga</span>
                  <span class="m-list-desc">{{
                    data.manifest.suku_bunga
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Denda / Pinalty</span>
                  <span class="m-list-desc">{{
                    data.manifest.denda_penalty
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Agunan</span>
                  <span class="m-list-desc">{{ data.manifest.angunan }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Jangka Waktu</span>
                  <span class="m-list-desc">
                    {{
                      data.header2.jkw_start_dt
                        ? moment(
                            data.header2.jkw_start_dt,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        : "-"
                    }}
                    s/d
                    {{
                      data.header2.jkw_end_dt
                        ? moment(
                            data.header2.jkw_end_dt,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        : "-"
                    }}
                  </span>
                </li>
                <li>
                  <span class="m-list-title" for>Provisi</span>
                  <span class="m-list-desc">
                    {{
                      formatCurrency(
                        "IDR",
                        data.header2.provisi ? data.header2.provisi : 0
                      )
                    }}
                  </span>
                </li>
                <li>
                  <span class="m-list-title" for>By. Administrasi</span>
                  <span class="m-list-desc">
                    {{ formatCurrency("IDR", data.header2.biaya_admin) }}
                  </span>
                </li>
                <li>
                  <span class="m-list-title" for>Jumlah Fasilitas</span>
                  <span class="m-list-desc">
                    {{ formatCurrency("IDR", data.header2.jml_fasilitas) }}
                  </span>
                </li>
                <li>
                  <span class="m-list-title" for>Used</span>
                  <span class="m-list-desc">
                    {{ formatCurrency("IDR", data.header2.pemakaian) }}
                  </span>
                </li>
                <li v-if="data.type == 'FK'">
                  <span class="m-list-title" for>Balance</span>
                  <span class="m-list-desc">
                    {{ formatCurrency("IDR", data.header2.balance) }}
                  </span>
                </li>
                <li>
                  <span class="m-list-title" for>Revision</span>
                  <span class="m-list-desc">
                    {{ data.header2.revisi_no }}
                  </span>
                </li>
              </ul>
            </div>
          </a-card>

          <a-card
            v-if="data.manifest.type_financing == 'FP'"
            title="Detail Pembayaran"
          >
            <a-table
              rowKey="id_financing_dtl"
              id="id_financing"
              :columns="columns"
              :dataSource="data.detail"
              :pagination="pagination"
              size="small"
              bordered
              :scroll="{ x: 650 }"
            >
              <div slot="no" slot-scope="item, record, index">
                {{ index + 1 }}
              </div>
              <a
                @click="handleDetail(item)"
                slot="bulan_tahun"
                slot-scope="item"
              >
                {{ item.bulan_tahun }}
              </a>
              <div slot="pokok" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="item.currency"
                  :valueNumber="parseFloat(item.pokok)"
                />
              </div>
              <div slot="bunga" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="item.currency"
                  :valueNumber="parseFloat(item.bunga)"
                />
              </div>
              <div slot="total_value" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="item.currency"
                  :valueNumber="parseFloat(item.total)"
                />
              </div>
            </a-table>
          </a-card>

          <a-card
            class="margin-top"
            :loading="loading"
            v-if="data.jenis === 'Approve'"
          >
            <a-form :form="form">
              <a-form-item label="Note">
                <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Actions">
                <a-select
                  showSearch
                  v-decorator="['aksi', { rules: [{ required: true }] }]"
                >
                  <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                    item.aksi
                  }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button
                  @click="handleAction"
                  :loading="loadingSave"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </a-form-item>
            </a-form>
          </a-card>
          <a-card
            class="margin-top"
            v-if="data.jenis === 'Transfer' && status_transfer"
          >
            <div slot="title">
              Manifest Actions &nbsp;<i
                v-if="data.jenis == 'Transfer' && !status_transfer"
                style="color: red !important"
                >(Funding has not been set)</i
              >
            </div>
            <div class="m-text-align right margin-remove" slot="extra">
              <h5 class="m-text-align right margin-remove">
                remaining balance
              </h5>
              <a-tag color="green" class="m-text-align right margin-remove">{{
                formatCurrency(data.currency, sisa_tf)
              }}</a-tag>
            </div>
            <template v-if="!(data.jenis == 'Transfer' && !status_transfer)">
              <a-form :form="formTransfer">
                <a-row :gutter="16">
                  <a-form-item label="Status">
                    <a-select
                      @change="onChangeStatus"
                      v-decorator="[
                        'aksi',
                        {
                          rules: [{ required: true }],
                          initialValue: data.aksi[0].aksi,
                        },
                      ]"
                    >
                      <a-select-option v-for="da in data.aksi" :key="da.aksi">{{
                        da.aksi
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Transfer Date">
                    <a-date-picker
                      placeholder="Select Date"
                      :format="dateFormat"
                      v-decorator="['tgl_tf', { rules: [{ required: true }] }]"
                    />
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Upload Bukti Transfer">
                    <a-upload
                      :fileList="fileList"
                      :disabled="fileList.length > 0"
                      v-decorator="[
                        'file_transfer',
                        { rules: [{ required: reqFileTf }] },
                      ]"
                      accept=".jpg, .png, .pdf"
                      :remove="handleRemove"
                      :beforeUpload="beforeUpload"
                    >
                      <a-button> <a-icon type="upload" />Select File </a-button>
                    </a-upload>
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Transfer Value">
                    <a-checkbox
                      :defaultChecked="true"
                      @change="onchangeNilaiTf"
                      :checked="checkTransferValue"
                      >Transfer value according to remaining balance</a-checkbox
                    >
                    <a-input-number
                      :min="0.1"
                      :max="sisa_tf"
                      class="m-display-block"
                      v-decorator="[
                        'value_transferan',
                        {
                          rules: [{ required: true }],
                          initialValue: temp_sisa_tf,
                        },
                      ]"
                      :disabled="disableNilaiTf"
                    ></a-input-number>
                  </a-form-item>

                  <a-form-item label="Note">
                    <a-textarea
                      placeholder="Write the note here ... "
                      :rows="4"
                      v-decorator="[
                        'catatan',
                        { rules: [{ required: false }] },
                      ]"
                    />
                  </a-form-item>
                </a-row>
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-button
                    @click="handleActionConfirm"
                    block
                    type="primary"
                    html-type="submit"
                    >Save</a-button
                  >
                </a-form-item>
              </a-form>
            </template>
          </a-card>
        </a-col>

        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-collapse activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status :status="data.last_status" />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    <a-icon type="undo" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">
                    Pembuat - {{ data.manifest.tlc_pembuat }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">
                      {{
                        moment(data.manifest.create_dt).format(
                          getDefaultDateFormat
                        )
                      }}
                    </h4>
                    <span class="m-text-small" v-if="data.manifest.catatan">{{
                      data.manifest.catatan
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  v-for="workflow in data.status"
                  :key="workflow.step_no"
                >
                  <div class="m-timeline-title">
                    {{ workflow.actor }} - {{ workflow.tlc }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove" v-if="workflow.tanggal_aksi">
                      {{
                        moment(workflow.tanggal_aksi).format(getDateTimeFormat)
                      }}
                    </h4>
                    <span class="m-text-small" v-if="workflow.remark">{{
                      workflow.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse :class="'margin-top'" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Document Support</h4>
              </div>
              <ul class="m-list-wrapper bordered">
                <li v-for="(dbt, index) in data.doc_support" :key="index">
                  <div
                    slot="title"
                    class="m-display-flex space-between align-middle nowrap"
                  >
                    <h4 class="margin-remove m-text-dots">
                      {{ dbt.filename }}
                    </h4>
                    <a-upload
                      class="upload-custom"
                      :fileList="dbt.fileList"
                      @preview="handlePreview"
                    ></a-upload>
                    <a-modal
                      :visible="previewVisible"
                      :footer="null"
                      @cancel="handleCancel"
                    >
                      <div class="margin-top"></div>
                      <a-divider class="margin-small" />
                      <img
                        alt="example"
                        style="width: 100%"
                        :src="previewImage"
                      />
                    </a-modal>
                  </div>
                </li>
              </ul>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse
            class="margin-top"
            activeKey="1"
            v-if="data.manifest.type_financing !== 'FP'"
          >
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Related Document</h4>
              </div>
              <a-list
                itemLayout="horizontal"
                :dataSource="data.related_document"
              >
                <Empty
                  v-if="
                    data.related_document
                      ? data.related_document.length <= 0
                      : data.related_document
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <a
                        @click="
                          handleView({
                            ...item,
                            id_manifest: item.id,
                          })
                        "
                        >{{ item.no_transaksi }}</a
                      >
                    </div>
                    <template slot="description">
                      <div>{{ item.description }}</div>
                      <div>{{ formatCurrency("", item.value) }}</div>
                      <div>{{ item.tanggal_permohonan }}</div>
                    </template>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>

          <a-card
            class="margin-top"
            v-if="data.manifest.type_financing == 'FP'"
            title="File Attachment"
          >
            <a-button
              @click="attachment = true"
              type="default"
              slot="extra"
              :disabled="data.last_status !== 'Approved'"
            >
              upload
              <a-icon type="upload" />
            </a-button>
            <a-list itemLayout="horizontal" :dataSource="data.lampiran">
              <Empty
                v-if="data.lampiran ? data.lampiran.length <= 0 : data.lampiran"
              />
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <div slot="title">
                    <a
                      @click="handleDownload(item)"
                      class="margin-remove m-text-dots"
                    >
                      {{ item.jenis ? item.jenis : "-" }}
                    </a>
                  </div>
                  <div slot="description">
                    <div class="m-display-flex space-between nowrap">
                      <h4 class="margin-remove m-text-dots">
                        {{ item.fungsi }}
                      </h4>
                      <a-button
                        v-if="data.manifest.prepared_by === getAuth.username"
                        @click="handleRemoveExisting(item.id_po_doc)"
                        size="small"
                        type="danger"
                        icon="delete"
                      ></a-button>
                    </div>
                    {{ item.tanggal }} | {{ item.tlc }}
                  </div>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </a-card>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">History Revision</h4>
              </div>
              <a-list itemLayout="horizontal" :dataSource="data.history_revisi">
                <Empty
                  v-if="
                    data.history_revisi
                      ? data.history_revisi.length <= 0
                      : data.history_revisi
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      {{ `Revisi No : ` + item.revisi_no }}
                      <div>{{ formatCurrency("", item.value) }}</div>
                    </div>
                    <template slot="description">
                      <div>{{ item.description }}</div>
                      <ul class="padding-remove">
                        <li
                          class="margin-top m-display-flex space-between align-top"
                          v-for="(data, index) in item.transaksi_transfer"
                          :key="data.id"
                        >
                          <div class="m-display-flex flex-column">
                            <span>{{ data.tgl_tf + " | " + data.tlc }}</span>
                            <span>{{
                              formatCurrency("", parseFloat(data.value_tf))
                            }}</span>
                          </div>
                          <a-button size="small" icon="eye" @click="handleDownload({ url: data.path})">
                            {{
                              index + 1 + "." + data.file_name.split(".").pop()
                            }}
                          </a-button>
                        </li>
                      </ul>
                    </template>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
    </div>

    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="reload" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }} | {{ history.tlc_to }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>

    <a-modal
      centered
      v-model="historyPayment"
      @ok="historyToggle"
      :footer="null"
    >
      <span slot="title"> <a-icon type="reload" />&nbsp;History Payment </span>

      <ul class="m-list-wrapper bordered">
        <li
          v-for="payment in historyPaymentData"
          :key="payment.id_payment_schedule"
        >
          <div class="m-display-flex space-between">
            <h3 class="margin-remove m-list-title">
              <a @click="handleLinkDetil(payment.id_payment_schedule)">
                {{ payment.no_payment_schedule }} | {{ payment.tlc_create }}
              </a>
            </h3>
          </div>
          <div class="m-display-flex space-between">
            <span class="margin-remove m-list-desc">
              Pokok
              {{ formatCurrency("IDR", payment.pokok ? payment.pokok : 0) }}
              | Bunga
              {{ formatCurrency("IDR", payment.bunga ? payment.bunga : 0) }}
            </span>
          </div>
          <div class="m-display-flex space-between">
            <span class="margin-remove m-list-desc">
              {{ moment(payment.create_dt).format(getDateTimeFormat) }}
            </span>
          </div>
        </li>
      </ul>
    </a-modal>

    <a-modal
      @ok="handleUploadDoc"
      :confirmLoading="attachmentForm.loading"
      okText="Submit Document"
      title="Upload Attachment"
      centered
      v-model="attachment"
    >
      <a-form-model
        ref="attachmentForm"
        :model="attachmentForm"
        :rules="attachmentRules"
      >
        <a-form-model-item label="Upload File" prop="file">
          <a-upload
            :fileList="attachmentForm.file"
            :beforeUpload="uploadAttachment"
            :remove="onRemoveAttachment"
            v-model="attachmentForm.file"
          >
            <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="Description" prop="description">
          <a-textarea v-model="attachmentForm.description" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import Axios from "axios";
import { mapGetters, mapActions } from "vuex";
import Status from "@/components/Status.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import lottie from "vue-lottie";
import notfound from "@/assets/anim/404.json";
import moment from "moment";
import _ from "lodash";
import ACol from "ant-design-vue/es/grid/Col";

export default {
  name: "FinancingManifest",
  components: {
    ACol,
    Status,
    "m-anim": lottie,
  },
  props: ["id", "user_pembuat"],
  mixins: [CurrencyFormat, HandleRoute],
  data() {
    const columns = [
      {
        title: "#",
        align: "left",
        width: 25,
        scopedSlots: { customRender: "no" },
      },
      {
        title: "Tempo Pembayaran",
        width: 250,
        scopedSlots: { customRender: "bulan_tahun" },
      },
      {
        title: "No BKK",
        width: 150,
        dataIndex: "no_bkk",
      },
      {
        title: "Pokok",
        width: 150,
        scopedSlots: { customRender: "pokok" },
      },
      {
        title: "Bunga",
        width: 150,
        scopedSlots: { customRender: "bunga" },
      },
      {
        title: "Total Value",
        width: 150,
        scopedSlots: { customRender: "total_value" },
      },
    ];
    return {
      columns,
      notfound: { animationData: notfound, loop: true },
      previewVisible: false,
      previewImage: "",
      loading: false,
      visibleHistory: false,
      data: {
        manifest: {},
        status: [],
        history: [],
        header2: {},
        can_edit: false,
        can_cancel: false,
        can_close: false,
        payment: [],
        doc_support: [],
        jenis: "",
        aksi: [],
      },
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      printLoad: {
        manifest: false,
        cancel: false,
      },
      historyPayment: false,
      historyPaymentData: [],
      loadingSave: false,
      reqFileTf: true,
      fileList: [],
      checkTransferValue: true,
      temp_sisa_tf: "",
      dateFormat: "DD MMMM YYYY",
      disableNilaiTf: true,
      attachment: false,
      attachmentForm: {
        loading: false,
        file: [],
        description: "",
      },
      attachmentRules: {
        file: {
          required: true,
          message: "please select your document",
          trigger: "change",
        },
        description: {
          required: true,
          message: "Please input keperluan",
          trigger: "change",
        },
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formTransfer = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStandartFormatDate",
      "getDefaultDateFormat",
      "getIsSpecialMenu",
      "getDateTimeFormat",
    ]),
  },
  methods: {
    ...mapActions(["FETCH_ALL_KURIR"]),
    moment,
    fetchManifest() {
      Axios({
        method: "get",
        url: this.$serviceUrl + "financing",
        params: {
          tlc: this.getAuth.username,
          id_manifest: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          try {
            this.data = {
              header2: response.data.header2[0],
              manifest: response.data.header1[0],
              status: response.data.status_app,
              history: response.data.history,
              detail: response.data.detil,
              doc_support: response.data.doc_support,
              type: response.data.header1[0].type_financing,
              pembayaran: response.data.payment,
              pemakaian: response.data.detil,
              can_edit: response.data.can_edit,
              can_cancel: response.data.can_cancel,
              can_close: response.data.can_close,
              jenis: response.data.jenis,
              aksi: response.data.aksi,
              last_status: response.data.last_status,
              currency: response.data.currency,
              related_document: response.data.related_doc,
              lampiran: response.data.lampiran,
              history_revisi: response.data.history_revisi_financing,
            };
            this.status_transfer = response.data.status;
            this.sisa_tf = response.data.sisa_tf;
            this.temp_sisa_tf = this.sisa_tf;
            let dbt = this.data.doc_support;
            for (const [i, val] of dbt.entries()) {
              let name = i + 1 + val.url.substring(val.url.lastIndexOf("."));
              this.data.doc_support[i]["fileList"] = [
                {
                  url: process.env.VUE_APP_SERVICEURL + val.url,
                  uid: i,
                  name: name,
                  status: "done",
                },
              ];
            }
            this.loading = false;
          } catch (err) {
            this.loading = false;
            this.displayMessageValue("error", err);
            this.$router.go(-1);
          }
        })
        .catch((err) => {
          if (!err.response) {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
            this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.loading = false;
            this.$router.push({ name: "beranda" });
          }
        });
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    handleViewDokument(data) {
      window.open(process.env.VUE_APP_SERVICEURL + data.url);
    },
    handlePreview(file) {
      if (file.url.substr(file.url.length - 3) === "pdf") {
        window.open(file.url, "_blank");
      } else {
        this.previewImage = file.url || file.thumbUrl;
        this.previewVisible = true;
      }
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handleEdit() {
      this.$router.push({
        name: "financing-edit",
        params: { id: this.id,type: "revisiwf" },
      });
    },
    handleLink(id) {
      this.historyPayment = true;
      this.historyPaymentData = this.data.payment.filter(
        (item) => item.id_financing_dtl == id
      );
    },
    handleLinkDetil(id) {
      this.$router.push({
        name: "PaymentScheduleManifestKeu",
        params: { id: id },
      });
    },
    handleLinkBKM(id) {
      this.$router.push({ name: "bkmManifestKeu", params: { id: id } });
    },
    handleCancelTrans() {
      this.confirmMessageValue("confirm-cancel", null, null);
    },
    canceltrans() {
      this.printLoad.cancel = true;
      const data = {
        tlc: this.getAuth.username,
        jenis_trans: "financing",
        id_manifest: this.id,
        code_trans: this.data.manifest.no_trans_financing,
      };
      this.$store
        .dispatch("cancelTransaction", { auth: this.getAuth, data: data })
        .then((response) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("successCancel", response.data.message);
          this.$router.go();
        })
        .catch((error) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("error", error.message);
        });
    },
    handleCloseTrans() {
      this.confirmMessageValue("confirm-close", null, null);
    },
    closetrans() {
      this.printLoad.cancel = true;
      const data = {
        id_financing: this.id,
      };
      // this.$store
      //   .dispatch("closeTransaction", { auth: this.getAuth, data: data, url:"financing/closed_financing" })

      Axios({
        method: "POST",
        url: this.$serviceUrl + "financing/close_financing",
        processData: false,
        data: data,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: { "X-API-KEY": this.getAuth.apikey },
      })
        .then((response) => {
          this.printLoad.close = false;
          this.displayMessageValue("successClose", response.data.message);
          this.$router.go();
        })
        .catch((error) => {
          this.printLoad.cancel = false;
          let response = Object.assign({}, error.response.data);
          if (response.status === false) {
            this.displayMessageValue("error-other", response.message);
          } else {
            //this.displayMessageValue("error-other", error);
            this.displayMessageValue("error", error.message);
          }
        });
    },
    handleAction() {
      this.confirmMessage("confirm-save");
    },
    handleActionProcess() {
      if (this.data.jenis === "Transfer") {
        this.handleActionTransfer();
      } else {
        this.handleActionAprove();
      }
    },
    handleActionAprove() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        let formData = new FormData();
        formData.append("id_manifest", this.id);
        formData.append("tlc", this.getAuth.username);
        formData.append("status", values.aksi);
        formData.append("remark", values.catatan ? values.catatan : "");

        this.loadingSave = true;
        Axios({
          method: "post",
          url: this.$serviceUrl + "financing/approval",
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.loadingSave = false;
            this.displayMessage("success");
            this.$router.go(0);
          })
          .catch((err) => {
            this.loadingSave = false;
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          });
      });
    },
    onChangeStatus(val) {
      if (val === "Transferred") {
        this.reqFileTf = true;
      }
    },
    uploadAttachment(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 30) {
        this.displayMessage("large-file-2mb");
      } else if (this.fungsi === "") {
        this.displayMessage("error-emptyDoc");
      } else {
        this.attachmentForm.file = [...this.attachmentForm.file, file];
        return false;
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 30) {
        this.displayMessage("large-file-5mb");
      } else {
        if (this.data.jenis === "Transfer") {
          this.fileList.push(file);
        } else {
          this.fileListLampiran.push(file);
        }
        return false;
      }
    },
    handleRemove(file) {
      if (this.data.jenis === "Transfer") {
        const index = this.fileList.indexOf(file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList;
      } else {
        const index = this.fileListLampiran.indexOf(file);
        const newFileList = this.fileListLampiran.slice();
        newFileList.splice(index, 1);
        this.fileListLampiran = newFileList;
      }
    },
    onchangeNilaiTf(e) {
      this.disableNilaiTf = e.target.checked;
      if (e.target.checked) {
        this.cek_value = 1;
        this.checkTransferValue = true;
        this.formTransfer.setFieldsValue({ value_transferan: this.sisa_tf });
      } else {
        this.cek_value = 0;
        this.checkTransferValue = false;
      }
    },
    handleActionConfirm() {
      this.confirmMessage("confirm-save");
    },
    handleActionTransfer() {
      this.formTransfer.validateFields((err, values) => {
        if (err) {
          return;
        }
        let formData = new FormData();
        formData.append("id_manifest", this.id);
        formData.append("tlc", this.getAuth.username);
        formData.append("status", values.aksi);
        formData.append("remark", values.catatan);

        if (this.checkTransferValue) {
          formData.append("cek_value", 1);
          formData.append("value_transfer", 0);
        } else {
          formData.append("cek_value", 0);
          formData.append("value_transfer", values.value_transferan);
        }
        formData.append(
          "tgl_transfer",
          moment(values.tgl_tf).format(this.getStandartFormatDate)
        );
        formData.append("file_transfer", values.file_transfer.file);

        this.loadingSave = true;
        Axios({
          method: "post",
          url: this.$serviceUrl + "financing/approval",
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.loadingSave = false;
            this.displayMessage("success");
            this.$router.go(0);
          })
          .catch((err) => {
            this.loadingSave = false;
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          });
      });
    },
    onRemoveAttachment() {
      this.attachmentForm.file = [];
    },
    handleUploadDoc() {
      if (
        this.$refs.attachmentForm.validate((valid) => {
          if (!valid) {
            this.displayMessage("form-warning");
            return;
          }

          this.attachmentForm.loading = true;

          let formData = new FormData();
          formData.append("tlc", this.getAuth.username);
          formData.append("id_manifest", this.id);
          formData.append("fungsi", this.attachmentForm.description);
          formData.append("nama_document", this.attachmentForm.file[0]);

          this.$store
            .dispatch("uploadDoc", {
              auth: this.getAuth,
              payload: formData,
            })
            .then((res) => {
              this.attachmentForm = {
                file: [],
                description: "",
              };
              this.attachment = false;
              this.fetchManifest();
              this.attachmentForm.loading = false;
              this.displayMessage("success-upload");
            });
        })
      );
    },
    handleDownload(item) {
      window.open(this.$serviceUrl + item.url, "_blank");
    },
    handleDetail(item) {
      this.historyPaymentData = item.history_payment;
      this.historyPayment = true;
    },
  },
  mounted() {
    this.fetchManifest();
    Event.$on("handleCancel", this.canceltrans);
    Event.$on("handleClose", this.closetrans);
    Event.$on("confirmMessageReturn", this.handleActionProcess);
  },
  beforeDestroy() {
    Event.$off("handleCancel", this.canceltrans);
    Event.$off("handleClose", this.closetrans);
    Event.$off("confirmMessageReturn", this.handleActionProcess);
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
        this.form = this.$form.createForm(this);
        this.formTransfer = this.$form.createForm(this);
        this.reqFileTf = true;
        this.fileList = [];
        this.checkTransferValue = true;
        this.disableNilaiTf = true;
      }
    },
  },
};
</script>

<style></style>
